import { Component, forwardRef, Input, Output } from '@angular/core';
import { IAbstractView } from '@core/interfaces';
import { IMenu } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { ComponentHostDirective } from './directives/component-host.directive';
import { StepMenuService } from './services/step-menu.service';
import { StepMenuPresenter } from './step-menu.presenter';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { IStepMenuComponent, IStepMenuPresenter } from './interfaces/step-menu-component.interface';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'app-step-menu',
	standalone: true,
	imports: [SharedModule, ReactiveFormsModule, FormsModule, ComponentHostDirective, IconComponent],
	templateUrl: './step-menu.component.html',
	styleUrl: './step-menu.component.scss',
	providers: [
		StepMenuService,
		StepMenuPresenter,
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => StepMenuComponent),
			multi: true,
		},
	],
})
export class StepMenuComponent<T = unknown, K = unknown>
	extends IAbstractView<IStepMenuPresenter<T, K>>
	implements IStepMenuComponent<T, K>
{
	activeStep = this.presenter.activeStep;
	lastStep = this.presenter.lastStep;
	formValid$ = this.presenter.formValid$;
	currentInstance = this.presenter.currentInstance;

	@Input() isStepper = this.presenter.isStepper;
	@Input() showButtonCancel = this.presenter.showButtonCancel;
	@Input({ required: true }) buttomFinishName = this.presenter.buttomFinishName;
	@Input() buttomFinishIco = this.presenter.buttomFinishIco;
	@Input({ required: true }) routeItems = this.presenter.routeItems;
	@Input() stepChange$ = this.presenter.stepChange$;
  	@Input() bodyTarget = this.presenter.bodyTarget;
  	@Input() isFinishStep = this.presenter.isFinishStep;
  	@Input() currentStep = this.presenter.currentStep;
  	@Input() loading$ = this.presenter.loading$;

	@Output() activeItemChange = this.presenter.activeItemChange;
	@Output() cancelChange = this.presenter.cancelChange;
	@Output() finishChange = this.presenter.finishChange;
	@Output() instanceCreated = this.presenter.instanceCreated;
	@Output() backToHome = this.presenter.backToHome;
	@Output() isFinishStepChange = this.presenter.isFinishStepChange;

	constructor(presenter: StepMenuPresenter<T, K>) {
		super(presenter);
	}

	// Propiedad enlazada a [(ngModel)]
	private _value: IMenu<T, K> | undefined = this.routeItems[0];

	// Callbacks para ControlValueAccessor
	private onChange: (_: IMenu<T>) => void = () => {};
	private onTouched: () => void = () => {};

	get value(): IMenu<T, K> | undefined {
		return this._value;
	}

	set value(value: IMenu<T>) {
		this._value = value;
		this.onChange(value); // Notificamos cambios
	}

	// Implementación de ControlValueAccessor
	writeValue(value: IMenu<T>): void {
		this._value = value;
	}

	registerOnChange(fn: () => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	cancelStep(): void {
		this.presenter.cancelStep();
	}

	prevStep(): void {
		this.presenter.prevStep();
	}

	nextStep(): void {
		this.presenter.nextStep();
	}

	finishStep(): void {
		this.presenter.finishStep();
	}

	onComponentInstanceCreated(instance: { instance: T; stepId: number }): void {
		this.presenter.onComponentInstanceCreated(instance);
	}

	onStepChange(step: number): void {
		this.presenter.onStepChange(step);
	}

	trackByRouteItem(index: number, _item: IMenu<T, K>): number {
		return this.presenter?.trackByRouteItem(index, _item);
	}

  getCurrentStep(index: number): number {
    
    return index + 1;
  }

  goBackToHome(): void {
    this.presenter.goBackToHome();
  }
}
